import React from 'react';
import TemplateDetail from '../enrich-template-detail-step';

export default function EnrichCustomPromptStep(props) {
  return <TemplateDetail enrichProspect {...props} />;
}
